export default __webpack_public_path__ + "static/media/pynwheel-logo.a4298ce0.png";